export default __webpack_public_path__ + "static/media/about2.e175f272.png";